import { render, staticRenderFns } from "./NewContactCard.vue?vue&type=template&id=bfb0584a&"
import script from "./NewContactCard.vue?vue&type=script&lang=ts&"
export * from "./NewContactCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports